<script lang="ts">
  import type { TeoView } from '@/teoCore/text/TextUi';
  import { Logo, type IconName } from '@/ui/base';
  import { ToolTipProvider } from '@/ui/base/tooltip';
  import NavButton from '@/ui/elements/buttons/NavButton.svelte';
  import VersionNavButton from '@/ui/elements/version/VersionNavButton.svelte';
  import { useTeoCore } from '@/utils/teo-context';
  import { useActiveTextUIView } from '@/utils/teo-context/teo-atoms/text';
  import { useDynamicConfigOption } from '@/utils/use-teo-event-observer.svelte';

  import ReportButton from '../report/ReportButton.svelte';

  let [selectedView, setSelectedView] = useActiveTextUIView();
  let core = useTeoCore();
  let brandFitEnabled = useDynamicConfigOption(core.dynamicConfig, 'brandFitEnabled');

  let navButtons = $derived(createNavButtons(brandFitEnabled.current));

  function createNavButtons(showBrandFit: boolean): Array<{
    label: string;
    icon: IconName;
    name: TeoView;
    condition?: () => boolean;
  }> {
    return [
      {
        label: 'Performance',
        icon: 'AutoGraph',
        name: 'performance',
      },
      {
        label: 'Brand Scanner',
        icon: 'Scan',
        name: 'brand-scanner',
        condition: () => showBrandFit,
      },
      {
        label: 'Stil',
        icon: 'Style',
        name: 'style',
      },
      {
        label: 'Wörterbuch',
        icon: 'Dictionary',
        name: 'dictionary',
      },
      {
        label: 'Rechtschreibung',
        icon: 'Spellcheck',
        name: 'spellcheck',
      },
      // {
      //   label: 'Leichte Sprache',
      //   icon: 'LeichteSprache',
      //   name: 'simple-language',
      // },
      {
        label: 'Einfache Sprache',
        icon: 'EinfacheSprache',
        name: 'plain-language',
      },
    ];
  }
</script>

<ToolTipProvider>
  <div class="fc-ssb f-0 h-full gap-4">
    <Logo scale={0.5} class="mb-10" />
    {#each navButtons as button (button.name)}
      {#if !button.condition || button.condition()}
        <NavButton
          icon={button.icon}
          label={button.label}
          selected={selectedView.current == button.name}
          onclick={() => setSelectedView(button.name)}
        />
      {/if}
    {/each}
    <div class="fc-se f-0 mt-auto gap-4">
      <ReportButton />
      <VersionNavButton />
    </div>
  </div>
</ToolTipProvider>
